module.exports = __webpack_public_path__ + "img/Vip_Card_6.d085ab9b.png";